import { render, staticRenderFns } from "./NewsListTemplate.vue?vue&type=template&id=0db5530c&scoped=true&"
import script from "./NewsListTemplate.vue?vue&type=script&lang=js&"
export * from "./NewsListTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewsListTemplate.vue?vue&type=style&index=0&id=0db5530c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5530c",
  null
  
)

export default component.exports